import { getWindowWidth } from './windowWidth'

export const defineHeader = async () => {
  if (import.meta.client) {
    const isSmallScreen = ['mobile', 'tablet'].includes(getWindowWidth())
    const { authenticated } = useAuth()

    if (isSmallScreen) {
      if (!authenticated.value) {
        return navigateTo('/login')
      }
    }
  }
}
